import React from 'react';
import * as ST from './styled';
var DefaultDots = function (_a) {
    var goToSlide = _a.goToSlide, slideCount = _a.slideCount, currentSlide = _a.currentSlide, autoplayInterval = _a.autoplayInterval, autoplay = _a.autoplay, customDotsStyles = _a.customDotsStyles;
    return (<ST.DotsContainer customStyles={customDotsStyles}>
            {Array(slideCount).fill(null).map(function (_, index) { return (<ST.DotContainer key={index} active={index === currentSlide} onClick={function () { return goToSlide(index); }} customStyles={customDotsStyles}>
                    <ST.Dot active={index === currentSlide} customStyles={customDotsStyles}/>
                    <ST.ActiveLine active={index === currentSlide} time={autoplay ? autoplayInterval / 1000 : 0} customStyles={customDotsStyles}/>
                </ST.DotContainer>); })}
        </ST.DotsContainer>);
};
export default DefaultDots;
